// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
  height: 100%;
  display: flex;
}

.dx-card {
  padding: 10px;
  width: 330px;
  margin: auto auto;
}
:host-context(.screen-x-small) .dx-card {
  width: 100%;
  height: 100%;
  border-radius: 0;
  box-shadow: none;
  margin: 0;
  border: 0;
}
.dx-card .content {
  padding: 40px;
}

.single-card-container {
  min-height: 100vh;
  background: url("/assets/img/bg.jpg");
  color: #253648;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-blend-mode: soft-light;
  background-color: rgba(240, 248, 255, 0.6509803922);
}

.single-card-header {
  background-color: #253648;
  color: #ffffff;
  border-bottom: 10px double white;
}

.single-card-header h1 {
  text-align: center;
  margin: 0;
  padding: 10px 0 0;
}

.single-card-body {
  width: 400px;
  margin: 0 auto;
  padding: 50px 0 150px;
  height: calc(100vh - 210px);
}

.single-card-footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  text-align: center;
  height: 100px;
  background-color: #253648;
  color: #ffffff;
  border-top: 10px double white;
}

.full-height-scrollable {
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/framework/single-card/single-card.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,iBAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,SAAA;AACJ;AAEE;EACE,aAAA;AAAJ;;AAMA;EAEE,iBAAA;EACA,qCAAA;EACA,cAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,iCAAA;EAEA,mDAAA;AALF;;AAQA;EACE,yBAAA;EACA,cAAA;EACA,gCAAA;AALF;;AAOA;EACE,kBAAA;EACA,SAAA;EACA,iBAAA;AAJF;;AAOA;EACE,YAAA;EACA,cAAA;EACA,qBAAA;EACA,2BAAA;AAJF;;AAOA;EACE,eAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,cAAA;EACA,6BAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;AAJF","sourcesContent":[":host {\n  width: 100%;\n  height: 100%;\n  display: flex;\n}\n\n.dx-card {\n  padding: 10px;\n  width: 330px;\n  margin: auto auto;\n\n  :host-context(.screen-x-small) & {\n    width: 100%;\n    height: 100%;\n    border-radius: 0;\n    box-shadow: none;\n    margin: 0;\n    border: 0;\n  }  \n  \n  .content {\n    padding: 40px;\n  }  \n}\n\n// pentru login\n\n.single-card-container {\n  // min-height: calc(100vh - 100px);\n  min-height: 100vh;\n  background: url('/assets/img/bg.jpg');\n  color: #253648;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-blend-mode: soft-light;\n  // background-color: #0480caed;\n  background-color: #f0f8ffa6;\n}\n\n.single-card-header{\n  background-color: #253648;\n  color: #ffffff;\n  border-bottom: 10px double white;\n}\n.single-card-header h1{\n  text-align: center;\n  margin:0;\n  padding: 10px 0 0;\n}\n\n.single-card-body {\n  width: 400px;\n  margin: 0 auto;\n  padding: 50px 0 150px;\n  height: calc(100vh - 210px);\n}\n\n.single-card-footer {\n  position: fixed;\n  width: 100%;\n  bottom: 0;\n  text-align: center;\n  height: 100px;\n  background-color: #253648;\n  color: #ffffff;\n  border-top: 10px double white;\n}\n\n.full-height-scrollable {\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
